export default __webpack_public_path__ + "static/als-floorsanding-407330fa24ce82a1a043cbf55cddcb6d.png";